import React from "react";
import {FormField} from "./FormField";
import {MultiFanFormData} from "./useMultiFanCriteriaForm";

interface MultiFanCriteriaFormProps {
    formData: MultiFanFormData;
    onFieldChange: (field: keyof Omit<MultiFanFormData, 'observerPosition'>, value: string) => void;
    onObserverPositionChange: (axis: 'xMeters' | 'yMeters' | 'zMeters', value: string) => void;
    onCalculate: () => void;
    totalFanCount: number;
    error: string;
}

export function MultiFanCriteriaForm({
                                         formData,
                                         onFieldChange,
                                         onObserverPositionChange,
                                         onCalculate,
                                         totalFanCount,
                                         error
                                     }: MultiFanCriteriaFormProps) {
    return (
        <div style={{flex: "0 0 50%", display: "flex", flexDirection: "column", gap: "20px"}}>
            {/* Wentylatory w chłodni */}
            <div>
                <h6 className="fw-bold mb-3">Wentylatory w chłodni</h6>
                <div className="row">
                    <FormField
                        label="PWL wentylatora [dBA]"
                        value={formData.fanPwlDba}
                        onChange={(v) => onFieldChange('fanPwlDba', v)}
                        floatingPoint={true}
                    />
                    <FormField
                        label="Dodatkowa moc akustyczna [dB(A)]"
                        value={formData.additionalUserGivenFanPwlDba}
                        onChange={(v) => onFieldChange('additionalUserGivenFanPwlDba', v)}
                        floatingPoint={true}
                    />
                    <FormField
                        label="Ilość kolumn wentylatorów"
                        value={formData.fanColumnCountInCooler}
                        onChange={(v) => onFieldChange('fanColumnCountInCooler', v)}
                        floatingPoint={false}
                    />
                    <FormField
                        label="Ilość wierszy wentylatorów"
                        value={formData.fanRowCountInCooler}
                        onChange={(v) => onFieldChange('fanRowCountInCooler', v)}
                        floatingPoint={false}
                    />
                    <FormField
                        label="Średnica obudowy [m]"
                        value={formData.fanCaseDiameterMeters}
                        onChange={(v) => onFieldChange('fanCaseDiameterMeters', v)}
                        floatingPoint={true}
                    />
                </div>
            </div>

            {/* Chłodnie */}
            <div>
                <h6 className="fw-bold mb-3">Chłodnie</h6>
                <div className="row">
                    <FormField
                        label="Szerokość chłodnicy [m]"
                        value={formData.coolerWidthMeters}
                        onChange={(v) => onFieldChange('coolerWidthMeters', v)}
                        floatingPoint={true}
                    />
                    <FormField
                        label="Wysokość chłodnicy [m]"
                        value={formData.coolerHeightMeters}
                        onChange={(v) => onFieldChange('coolerHeightMeters', v)}
                        floatingPoint={true}
                    />
                    <FormField
                        label="Wysokość wentylatora nad ziemią [m]"
                        value={formData.coolerZCoordinate}
                        onChange={(v) => onFieldChange('coolerZCoordinate', v)}
                        floatingPoint={true}
                    />
                    <FormField
                        label="Ilość kolumn chłodnic"
                        value={formData.totalCoolerColumnCount}
                        onChange={(v) => onFieldChange('totalCoolerColumnCount', v)}
                        floatingPoint={false}
                    />
                    <FormField
                        label="Ilość wierszy chłodnic"
                        value={formData.totalCoolerRowCount}
                        onChange={(v) => onFieldChange('totalCoolerRowCount', v)}
                        floatingPoint={false}
                    />
                    <div className={`col-4 mb-3`}></div>
                    <FormField
                        label="Odległość X między chłodnicami [m]"
                        value={formData.xDistanceBetweebCoolers}
                        onChange={(v) => onFieldChange('xDistanceBetweebCoolers', v)}
                        floatingPoint={true}
                    />
                    <FormField
                        label="Odległość Y między chłodnicami [m]"
                        value={formData.yDistanceBetweebCoolers}
                        onChange={(v) => onFieldChange('yDistanceBetweebCoolers', v)}
                        floatingPoint={true}
                    />
                </div>
            </div>

            {/* Obserwator */}
            <div>
                <h6 className="fw-bold mb-3">Obserwator</h6>
                <div className="row">
                    <FormField
                        label="Pozycja X [m]"
                        value={formData.observerPosition.xMeters}
                        onChange={(v) => onObserverPositionChange('xMeters', v)}
                        floatingPoint={true}
                    />
                    <FormField
                        label="Pozycja Y [m]"
                        value={formData.observerPosition.yMeters}
                        onChange={(v) => onObserverPositionChange('yMeters', v)}
                        floatingPoint={true}
                    />
                    <FormField
                        label="Pozycja Z [m]"
                        value={formData.observerPosition.zMeters}
                        onChange={(v) => onObserverPositionChange('zMeters', v)}
                        floatingPoint={true}
                    />
                </div>
            </div>

            <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>

                <button
                    onClick={onCalculate}
                    className="btn btn-primary"
                    style={{
                        padding: "10px",
                        fontSize: "14px",
                        fontWeight: "bold"
                    }}
                >
                    Oblicz
                </button>

                {error && (
                    <div style={{
                        padding: "10px",
                        backgroundColor: "#ffebee",
                        color: "#c62828",
                        borderRadius: "4px",
                        fontSize: "12px",
                        border: "1px solid #ef5350"
                    }}>
                        {error}
                    </div>
                )}
            </div>
        </div>
    );
}
